import BaseParameterAction from './BaseParameterAction.js';

class RemoveAutomationBreakPointAction extends BaseParameterAction {
    execute({automation, point}) {
        automation.removeBreakPoint(point);
    }

    undo({payload}) {
        payload.automation.addBreakPoint(
            payload.point.step,
            payload.point.value,
            payload.point.id);
    }
}

export default RemoveAutomationBreakPointAction;
